import service from './service'
import workingReport from './workingReport'

export default [
  {
    header: 'breadcrumb.working',
    resource: 'working-header',
  },
  ...service,
  ...workingReport,
]
